import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { IntegrationCRMUser } from 'voxloud-types/dist/models/integrations';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-integration-select-user',
  templateUrl: './integration-select-user.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: IntegrationSelectUserComponent
    }
  ]
})
export class IntegrationSelectUserComponent implements ControlValueAccessor {
  @Input() users: IntegrationCRMUser[]
  private onChange: (_) => any;
  private onTouch: (_) => any;
  private disabled: boolean;
  private control = new UntypedFormControl();
  public error: string = null;



  private findMatchingUser(v: IntegrationCRMUser | string): IntegrationCRMUser {
    if (!this.users || this.users.length === 0 || [null, undefined].includes(v)) {
      return null;
    }
  
    return this.users.find((u: IntegrationCRMUser) => {
      if (typeof v === 'string') {
        return u.external_id.includes(v);
      } else if (typeof v === 'object' && v !== null) {
        return u.external_id === v.external_id;
      }
      return false;
    }) || null;
  }

  public selectUser(u: IntegrationCRMUser) {
    this.control.setValue(u);
    this.onChange(u);
  }

  public get selected() {
    return this.control.value?.full_name ? this.control.value?.full_name : '-';
  }

  writeValue(v: IntegrationCRMUser | string): void {
    this.control.setValue(
      this.findMatchingUser(v)
    );
    this.onChange && this.onChange(this.control.value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
